import React, { memo } from 'react';
export const ForWhoSection = memo(function ForWhoSection() {
  const avatars = [{
    icon: '🏠',
    title: 'Tu sueldo no alcanza y no tenés un oficio que te respalde',
    desc: 'La electricidad es el oficio más demandado de Argentina y el Megapack te enseña a dominarlo desde cero.'
  }, {
    icon: '💸',
    title: 'Pagás fortunas por arreglos que podrías hacer vos mismo',
    desc: 'El técnico cobra lo que ganás en medio día por 20 minutos de trabajo. Eso se termina acá.'
  }, {
    icon: '😰',
    title: 'Querés aprender un oficio serio pero no sabés por dónde empezar',
    desc: 'Sin experiencia previa. Sin tecnicismos. De cero a profesional a tu propio ritmo.'
  }, {
    icon: '💡',
    title: 'Querés entender y controlar la electricidad de tu casa',
    desc: 'Por qué salta el diferencial, cómo leer tu tablero y qué hacer en una emergencia. Todo resuelto.'
  }];
  return <section className="py-10 px-4 bg-gray-50 border-t border-gray-200" data-id="element-68">
      <div className="max-w-2xl mx-auto" data-id="element-69">
        {/* Header */}
        <h2 className="text-[22px] md:text-3xl font-black text-gray-900 text-center mb-6 leading-tight" data-id="element-70">
          Este Megapack{' '}
          <span className="text-blue-600" data-id="element-71">es para vos si...</span>
        </h2>

        {/* Lista */}
        <div className="space-y-3" data-id="element-72">
          {avatars.map((avatar, index) => <div key={index} className="flex items-start gap-4 bg-white border border-gray-200 rounded-xl px-5 py-4 hover:border-blue-300 transition-colors shadow-sm" data-id="element-73">
              <span className="text-2xl flex-shrink-0 mt-0.5" data-id="element-74">
                {avatar.icon}
              </span>
              <div data-id="element-75">
                <p className="text-gray-900 font-black text-[13px] md:text-sm leading-snug" data-id="element-76">
                  {avatar.title}
                </p>
                <p className="text-gray-600 text-[11px] md:text-xs leading-relaxed mt-1" data-id="element-77">
                  {avatar.desc}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
});